import { useDispatch, useSelector } from 'react-redux'
import DailyAttendanceForm from '../../Utilities/Form'
import { useParams, useSearchParams } from 'react-router-dom'
import { get as getStudentAttendance } from 'store/attendance/attendance'
import { useEffect, useState } from 'react'

export default function DailyAttendanceFormIndex() {
  const { id } = useParams()
  const dispatch = useDispatch()
  const [isReady, setIsReady] = useState(false)
  let selected = useSelector(state => state.attendance.attendance?.selected)
  const basePath = `/attendance/daily/`

  const [searchParams] = useSearchParams()
  const date = searchParams.get('date')
  const schoolEnrollmentId = searchParams.get('schoolEnrollmentId')

  useEffect(() => {
    if (parseInt(id)) {
      dispatch(getStudentAttendance({ id })).then(() => {
        setIsReady(true)
      })
    } else if (id === 'new') {
      dispatch(getStudentAttendance({ id, schoolEnrollmentId: parseInt(schoolEnrollmentId), date })).then(() => {
        setIsReady(true)
      })
    }
  }, [id])

  if (!selected) return null
  if (isReady) {
    return <DailyAttendanceForm basePath={basePath} selected={selected} />
  }
}
